import { render, staticRenderFns } from "./GalleryFTP.vue?vue&type=template&id=d44860ac&"
import script from "./GalleryFTP.vue?vue&type=script&lang=ts&"
export * from "./GalleryFTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports